import { render, staticRenderFns } from "./StatisticOrganize.vue?vue&type=template&id=0b7f305c"
import script from "./StatisticOrganize.vue?vue&type=script&lang=js"
export * from "./StatisticOrganize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports